export const fetchUpdateSession = async ({ BeURL, item }) => {
    try {
        const res = await fetch(
            `${BeURL}/fetch-update-session?id=${encodeURIComponent(item)}`,
            {
                method: "GET",
                credentials: "include",
            }
        );

        if (!res.ok) {
            throw new Error("Failed to fetch updated session");
        }

        const data = await res.json();
        return data;

    } catch (err) {
        console.error("fetchUpdateSession error:", err);
        return { success: false, message: err.message };
    }
};
